import { render, staticRenderFns } from "./SalesQuickOrder.vue?vue&type=template&id=db9d323c"
import script from "./SalesQuickOrder.vue?vue&type=script&lang=js"
export * from "./SalesQuickOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports